import Cookies from 'js-cookie';
import { useSelector } from 'react-redux';

export const resolveAccessToken = (reduxToken) => (
  reduxToken || Cookies.get('accessToken') || null
);

export const usePartnerAccessToken = () => {
  const reduxToken = useSelector((state) => state.auth?.accessToken);
  return resolveAccessToken(reduxToken);
};
